module.exports = __webpack_public_path__ + "media/images/top/reserved_t-228f8b883b9cb0d6a542e082119357d4.gif";